__turbopack_context__.v({
  "compact": "garanti-secure-payment-module__XMKfZq__compact",
  "copy": "garanti-secure-payment-module__XMKfZq__copy",
  "header": "garanti-secure-payment-module__XMKfZq__header",
  "logo": "garanti-secure-payment-module__XMKfZq__logo",
  "root": "garanti-secure-payment-module__XMKfZq__root",
});
